export const notificationDrawer = {
  notificationDrawerTitle: "Notifications",
  notificationDrawerDeleteBtn: "Delete",
  notificationDrawerDeletedNotification: "Notification deleted",
  notificationDrawerDeletedFailed: "Notification delete failed",
  notificationMarkReadFailed: "Notification mark as read failed",
  notificationDrawerNotifications: "No notifications",
  notificationDrawerPlay: "Play",
  notificationDrawerPlayGame: "Go to game",
  notificationClose: "Close",
  notificationJustNow: "Just now",
  notificationMarkRead: "Mark as read",
  notificationTagNews: "News",
  notificationTagPush: "Alert",
  notificationTagBreaking: "Promos & more",
  notificationTagMovement: "Movement",
  notificationTab_all: "All",
  notificationTab_news: "News",
  notificationTab_breaking: "Promos & more",
  notificationTab_movements: "Movements",
  notificationEmptySubtext: "When you have new notifications they'll show up here",
  notificationNewsCta: "Click to learn more",
  bankStatusOk: "All banks operational, you're good to go! \uD83D\uDC9A",
  bankStatusDown: "is currently down, hang tight \uD83D\uDEA8",
};
